import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles'
import { withRtl } from '../hoc';
import CustomHeading from '../CustomHeading';
import style from './SchoolHeader.scss';
import Tooltip from '../Tooltip';

import { getPublicSchoolLink, processNameToShortCode } from '../../utils/helpers';
import Share from '../Share';
import CaretDownIcon from '../icons/CaretDown';
import PrinterIcon from '../icons/Printer';
// import SchoolIcon from '../icons/School';

const localMessages = defineMessages({
  print: {
    id: 'schoolheader.print',
    defaultMessage: 'Print',
    description: 'text for the print feature',
  }
});

class SchoolHeader extends Component {
  static propTypes = {
    id: PropTypes.number,
    headerId: PropTypes.number,
    getStats: PropTypes.func.isRequired,
    hovered: PropTypes.bool,
    loggedIn: PropTypes.bool.isRequired,
    onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    opened: PropTypes.bool,
    isAffiliatedSRLocation: PropTypes.bool,
    zonedSchool: PropTypes.bool,
    zonedSchoolIdText: PropTypes.string,
    affiliatedSRLocationText: PropTypes.string,
    title: PropTypes.string.isRequired,
    intl: PropTypes.shape().isRequired,
    showShare: PropTypes.bool,
    // headingTagName: PropTypes.string,
    school: PropTypes.shape({
      district: PropTypes.shape({
        code: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    programOpen: PropTypes.number,
    eligibility: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ),
    admissionProcess: PropTypes.string,
    dbn: PropTypes.string,
  };

  static defaultProps = {
    id: null,
    headerId: null,
    hovered: false,
    onClick: false,
    opened: false,
    isAffiliatedSRLocation: false,
    zonedSchool: false,
    affiliatedSRLocationText: '',
    zonedSchoolIdText: '',
    showShare: false,
    programOpen: 0,
    eligibility: null,
    admissionProcess: null,
    // headingTagName: 'h1',
  };

  constructor(props) {
    super(props);
    this.state = {
      hovered: props.hovered,
    };
  }

  componentDidMount() {
    if (this.props.programOpen && this.props.headerId) {
      document.getElementById(this.props.headerId).focus();
    }
  }

  componentDidUpdate() {
    if (this.props.programOpen && this.props.headerId) {
      document.getElementById(this.props.headerId).focus();
    }
  }

  onMouseEnter = () => {
    this.setState({
      ...this.state,
      hovered: true,
    });
  };

  onMouseLeave = () => {
    this.setState({
      ...this.state,
      hovered: false,
    });
  };

  handlePrintClick=()=> {
    window.print();
  }

  render() {
    const {
      loggedIn,
      onClick,
      opened,
      isAffiliatedSRLocation,
      affiliatedSRLocationText,
      getStats,
      title,
      id,
      intl,
      showShare,
      headerId,
      eligibility,
      admissionProcess,
      dbn,
      zonedSchool,
      zonedSchoolIdText,
    } = this.props;
    const { hovered } = this.state;

    const is3KApp = admissionProcess === '3K';
    const isPKApp = admissionProcess === 'PK';
    const isKApp = admissionProcess === 'K';
    const isGTApp = admissionProcess === 'GTAPP';
    const isMSApp = admissionProcess === 'MS';
    const isHSApp = admissionProcess === 'HS';

    const showAffiliated =
      isAffiliatedSRLocation ||
      (zonedSchool && (is3KApp || isPKApp || isKApp || isGTApp || isMSApp || isHSApp));

    const moduleClass = classNames(style.root, {
      [style.rootHovered]: hovered,
      [style.rootOpened]: opened,
      [style.studentAffiliatedSchool]: showAffiliated,
    });
    const caretClasses = [style.caret];
    if (opened) {
      caretClasses.push(style.caretOpened);
    }
    // const caretClass = classNames(style.caret, {
    //   [style.caretClosed]: !opened,
    //   [style.caretOpened]: opened,
    // });
    // const linkProps = onClick ? { onClick } : {};

    const headingBody = (
      <Fragment>
        <span aria-label={`${title}.`}>{title}</span>
        <span className={classNames(...caretClasses) + ' exclude-print'}>
          <CaretDownIcon width={18} height={10} fill={hovered ? '#024cbc' : '#000'} />
        </span>
      </Fragment>
    );

    const schoolLink = getPublicSchoolLink({
      directorySchoolId: id,
      locale: intl.locale,
      admissionProcess,
      dbn
    });

    const parts = window.location.pathname.split('/');
    const processName = parts.pop() || parts.pop(); // handle potential trailing slash
    const loggedOutAdmissionProcess = processNameToShortCode({ processName });

    return (
      <header className={moduleClass}>
        {isAffiliatedSRLocation && affiliatedSRLocationText != '' && (
          <div className={style.affiliatedSummerRisingLocationIdentifier}
            dangerouslySetInnerHTML={{ __html: affiliatedSRLocationText }}
          />
        )}

        {zonedSchool && zonedSchoolIdText !== '' && (
          <div className={style.affiliatedSummerRisingLocationIdentifier}>
            {zonedSchoolIdText}
          </div>
        )}

        <div
          role="button"
          tabIndex="0"
          id={headerId}
          onKeyDown={event => onClick(event)}
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
          onClick={event => onClick(event)}
          aria-expanded={opened}
        >
          {/* <CustomHeading body={headingBody} headingProps={{ className: style.title }} tagName={headingTagName} /> */}
          <CustomHeading body={headingBody} headingProps={{ className: style.title }} />
        </div>
        {eligibility &&
          (admissionProcess === 'MS' ||
            admissionProcess === 'K' ||
            admissionProcess === 'PK' ||
            admissionProcess === '2K' ||
            admissionProcess === '3K' ||
            loggedOutAdmissionProcess === 'MS' ||
            loggedOutAdmissionProcess === 'K' ||
            loggedOutAdmissionProcess === 'PK' ||
            loggedOutAdmissionProcess === '2K' ||
            loggedOutAdmissionProcess === '3K') &&
          eligibility[0] && (
            <div className={style.middleSchoolType}>
              {eligibility[0].name}
              {(admissionProcess === 'K' ||
                admissionProcess === 'PK' ||
                admissionProcess === '2K' ||
                admissionProcess === '3K' ||
                loggedOutAdmissionProcess === 'K' ||
                loggedOutAdmissionProcess === 'PK' ||
                loggedOutAdmissionProcess === '2K' ||
                loggedOutAdmissionProcess === '3K') &&
                `| District ${this.props.school.district.code}`}
            </div>
          )}
        <div className={style.content}>
          <ul className={style.stats} data-coachmark="search-mobile-step-4">
            {getStats(loggedIn, admissionProcess).map((stat, index) => (
              <li className={style.stat + ' ' + style.iconLabelInline} key={stat.key} data-coachmark={index === 0 ? 'search-step-4' : ''}>
                <Tooltip
                  icon={stat.icon}
                  label={stat.label}
                  ariaLabel={`${intl.formatMessage(stat.ariaLabel, stat.ariaLabelMessageData)}: ${stat.label.replace(
                    /\s/g,
                    '',
                  )}.`}
                >
                  {stat.tip}
                </Tooltip>
              </li>
            ))}
          </ul>
          {showShare && (
            <button onClick={this.handlePrintClick} className={style.print + " exclude-print"}>
              <PrinterIcon fill="#024CBC" size={18} />
              {intl.formatMessage(localMessages.print)}
            </button>
          )}
          {/* TODO: add MS back in when routes are all set and we have admissionProcess */}
          {showShare && (admissionProcess !== 'MS' || admissionProcess !== 'K') && loggedIn && (
            <div>
              <Share text={schoolLink} dbn={dbn} stopPropagation />
            </div>
          )}
        </div>
      </header>
    );
  }
}

// export { SchoolHeader };
export default withRtl(style)(withStyles(style)(injectIntl(SchoolHeader)));
